module.exports = __webpack_public_path__ + "img/motorway_3x4.559fe95f.svg";